import { createContext, useContext } from "react";

export interface CommandPaletteContextProps {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const CommandPaletteContext =
  createContext<CommandPaletteContextProps | null>(null);

export const useCommandPalette = (): CommandPaletteContextProps => {
  const ctx = useContext(CommandPaletteContext);
  if (!ctx) {
    throw new Error(
      "useCommandPalette must be used within CommandPaletteProvider",
    );
  }
  return ctx;
};
